import React from 'react';
import clsx from 'clsx';
import Icon from '../atoms/Icon';
import Progress from '../atoms/Progress';
import { randomInt } from '../../lib/utils';
import styles from '../../styles/components/molecules/Ratings.module.scss';

interface RatingsProps {
  className?: string;
  label?: string;
  value: number;
  decs?: number;
  data: {
    label?: string;
    value: number;
  }[];
}

export default function Ratings({
  label,
  value,
  data,
  decs = 1,
  className,
}: RatingsProps) {
  const { ratings } = styles;
  const classes = clsx(ratings, className);
  const maxStars = 5;
  const totalStars =
    value ||
    data.reduce((acc, curr) => acc + curr.value, 0) /
      (data.filter((el) => el.value > 0).length || 1);

  return (
    <div className={classes}>
      <p>
        <Icon name="rating" />
        <small>
          <b>{totalStars.toFixed(decs).replace('0.0', '0')}</b>
        </small>
        <span>{label}</span>
      </p>
      <ul>
        {data.map((el, i) => {
          const perc = (el.value * 100) / maxStars;
          const stars = el.value.toFixed(decs).replace('0.0', '0');
          return (
            <li key={`ratings-${i}`}>
              <Progress value={perc} animateIn />
              <small>
                <b>{stars}</b> {el.label}
              </small>
              <br />
              <br />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
